import classnames from 'classnames'
import { Component } from 'preact'
import { connect } from 'react-redux'
import { getP } from 'redux-polyglot'
import { acknowledgeGlobalMessage } from '../../actions/app'
import Focusable from '../focusable'
import styles from './global-message.css'

class GlobalMessage extends Component {
  constructor(props) {
    super(props)
    this.scroller = null
    this.state = {
      arrowUp: false,
      arrowDown: false
    }
  }

  attachArrowHandle = el => {
    if (el) {
      this.scroller = el
      el.addEventListener('scroll', _ => {
        this.handleArrows(el)
      })
      setTimeout(() => {
        this.handleArrows(el)
      }, 0)
    }
  }

  handleArrows = el => {
    if (el.scrollTop === 0) {
      this.setState({
        arrowUp: false
      })
    } else {
      this.setState({
        arrowUp: true
      })
    }
    if (el.scrollTop + el.clientHeight >= el.scrollHeight) {
      this.setState({
        arrowDown: false
      })
    } else {
      this.setState({
        arrowDown: true
      })
    }
  }

  scrollUp = _ => {
    if (this.scroller !== null) {
      this.scroller.scrollTop = this.scroller.scrollTop - 50
    }
  }

  scrollDown = _ => {
    if (this.scroller !== null) {
      this.scroller.scrollTop = this.scroller.scrollTop + 50
    }
  }

  render({ title, message, buttonMessage, acknowledgeGlobalMessage, polyglot: { t } }) {
    return (
      <div class={classnames('verticalAlign', styles.globalMessageComponent)}>
        <div class={styles.content}>
          <div class={styles.title}>{title}</div>
          <div
            class={classnames(styles.arrow, {
              [styles.visible]: this.state.arrowUp
            })}>
            <span class={styles.arrowUp}></span>
          </div>
          <div class={styles.scroller} ref={this.attachArrowHandle}>
            <div
              class={styles.message}
              dangerouslySetInnerHTML={{
                __html: message
              }}></div>
          </div>
          <div
            class={classnames(styles.arrow, {
              [styles.visible]: this.state.arrowDown
            })}>
            <span class={styles.arrowDown}></span>
          </div>
          <Focusable
            isFocused={true}
            onBack={acknowledgeGlobalMessage}
            onEnter={acknowledgeGlobalMessage}
            class={styles.btn}
            onArrowUp={this.scrollUp}
            onArrowDown={this.scrollDown}>
            {buttonMessage
              ? buttonMessage
              : t('tv_app.button_acknowledge', { _: 'OK, I Understand' })}
          </Focusable>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  polyglot: getP(state)
})

const mapDispatchToProps = {
  acknowledgeGlobalMessage
}

export default connect(mapStateToProps, mapDispatchToProps)(GlobalMessage)
